import React from "react"
import Header from "../../components/Header"
import Layout from "../../components/Layout"

import RequestDemo from "../../components/RequestDemo"
import MagicWithUs from "../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="Book Premagic Demo - AI Event Platform Live Tour"
      description="See Premagic's AI event platform in action. Book a personalized demo and transform your events into revenue machines."
      keywords={[
        "Premagic demo request, AI event platform demo, event technology demo, live platform demonstration, event management demo, AI photo sharing demo, corporate event demo, conference platform demo, event networking demo, personalized event demo, enterprise event demo, event ROI demo, photo distribution demo, event tech consultation, platform walkthrough",
      ]}
    >
      <Header />
      <RequestDemo />
    </Layout>
  )
}

export default Index
